var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetarian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287 410 c-10 -25 -17 -30 -46 -30 -90 0 -252 -263 -201 -325 26 -32 124 -11 203 43 68 48 126 112 133 149 5 28 10 33 35 33 22 0 30 6 35 25 3 14 2 31 -4 38 -5 6 -12 25 -16 40 -5 20 -14 29 -36 34 -17 3 -33 10 -36 14 -3 5 -17 9 -30 9 -19 0 -29 -8 -37 -30z m53 -20 c0 -21 24 -28 35 -10 4 6 11 7 17 4 6 -4 6 -10 -1 -17 -18 -18 -13 -37 9 -37 11 0 20 -4 20 -10 0 -5 -12 -10 -27 -10 -20 0 -36 10 -55 34 -31 39 -36 66 -13 66 8 0 15 -9 15 -20z m-28 -67 c42 -45 45 -75 10 -114 l-30 -34 -24 23 c-44 41 -68 19 -26 -25 21 -23 21 -23 2 -38 -49 -37 -61 -39 -90 -16 -15 11 -31 21 -35 21 -15 0 -10 -27 6 -40 20 -17 3 -30 -37 -30 -21 0 -28 5 -28 20 0 26 39 130 49 130 4 0 16 -9 26 -20 10 -11 22 -20 27 -20 15 0 8 23 -13 46 l-21 23 27 35 c32 43 44 44 75 11 23 -24 50 -33 50 -17 0 5 -11 19 -25 32 -32 30 -32 40 3 40 18 0 38 -10 54 -27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/vegetarian.90ef0f9fdd01974d4138694515c9b602.svg";
export { ForwardRef as ReactComponent };